import { createApp } from 'vue'
import './style.css'
import App from './App.vue'
import router from './router'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import logger from './server/utilities/frontend_logger.js'
import CurrencyDisplay from './components/CurrencyDisplay.vue'

const app = createApp(App)
app.component('CurrencyDisplay', CurrencyDisplay)

app.use(router)
app.use(ElementPlus)
app.use(logger)

app.mount('#app')
